<template>

  <ModalContainer queryParam="sessions" ref="modalContainer" size="lg">

    <b-card class="mb-0">
      <h3 class="text-center mb-2">Sesiones de terapias</h3>

      <span v-if="dataTerapia" class="my-1">
        <div class="row">
          <b class="col-2">Paciente:</b> {{ dataTerapia.paciente }}
        </div>

        <div class="row">
          <b class="col-2">Doctor:</b> {{ dataTerapia.doctor }}
        </div>

        <div class="row">
          <b class="col-2">Terapia:</b> {{ dataTerapia.terapia }}
        </div>

        <div class="row">
          <b class="col-2">Sesiones:</b> {{ dataTerapia.cantidad }}
        </div>
            <div class="row">
          <b class="col-2">Motivo:</b> {{ dataTerapia.motivoTerapia }}
        </div>
          <div class="row">
          <b class="col-2">Resumen:</b> {{ dataTerapia.resumenClinico }}
        </div>
      </span>


      <hr>

      <div v-if="!onlyView" class="row d-flex align-items-center">
        <span class="col-3">Fecha de session:</span>

        <flat-pickr v-if="!onlyView" v-model="fechaSesion" placeholder="DD/MM/AAAA" :config="configFlatPicker"
          class="form-control col-3" />

           <b-col>
            
            
                <vue-timepicker v-if="!onlyView" v-model="horaSession" fixed-dropdown-button format="HH:mm" manual-input>
              <template v-slot:dropdownButton>
                <i class="fa-regular fa-clock"></i>
              </template>

            </vue-timepicker>
              <!-- <b-timepicker class="col-6" v-model="horaActual" locale="es" format="HH:mm" size="sm" /> -->
            </b-col>
        
          <!-- <b-timepicker class="col-3 ml-2" v-model="horaSession" locale="es" format="HH:mm" size="sm" /> -->

        <b-button v-if="!onlyView" variant="warning" class="ml-2" @click="addSesion" size="sm">
          Agregar Sesion
        </b-button>
      </div>


    <b-alert
  v-for="(item, index) in sesionesOrdenadas"
  :key="index"
  show
  :variant="getVariantCard(item.action)"
  class="my-2 p-1"
>
  <div class="d-flex justify-content-between align-items-center mb-2">
    <strong>Sesion #{{ index + 1 }}</strong>
    <span class="text-muted">{{ item.action.toUpperCase() }}</span>

    <b-button
      v-if="item.action !== 'eliminar' && !onlyView"
      variant="danger"
      size="sm"
      class="ml-1"
      @click="onRemoveItemList(index)"
    >
      <i class="fa-solid fa-x" />
    </b-button>

    <b-button
      v-if="item.action === 'eliminar' && !onlyView"
      variant="warning"
      size="sm"
      class="ml-1"
      @click="onRestoreItem(index)"
      title="Restaurar Item"
    >
      <i class="fa-solid fa-rotate-right" />
    </b-button>
  </div>

  

  <div class="row d-flex align-items-center">
    <div class="col-9">
      <b-row class="d-flex align-items-center mb-1">
        <strong class="col-2">Estado:</strong>
        <span class="text-dark col">{{ item.estadoSesion }}</span>
      </b-row>

      <b-row class="d-flex align-items-center mb-1">
        <strong class="col-2">Fecha:</strong>
        <span class="text-dark col">{{ item.fechaSesion }}</span>
      </b-row>

      <b-row class="d-flex align-items-center mb-1">
        <strong class="col-2">Hora:</strong>
        <span class="text-dark col">{{ item.horaSesion }}</span>
      </b-row>

      <b-row class="d-flex align-items-center mb-1">
        <strong class="col-2">Doctor:</strong>
        <span class="text-dark col">{{ dataTerapia.doctor }}</span>
      </b-row>
    </div>

    <div class="col-3">
      <b-button
        v-if="item.action === 'registrado'"
        variant="success"
        @click="onProcesarSesion(item)"
      >
        Procesar
      </b-button>
        <b-button
              v-if="dataTerapia.tipoCobertura.descripcion !== 'PARTICULAR' && item.action === 'registrado' "
              class="mt-1"
              variant="primary"
              title="MSP"
              size="sm"
              @click="onShowFormMsp(item.tokenSesion)"
            >
              MSP
            </b-button>
    </div>
    
  </div>
</b-alert>

      <EmptyResults v-if="!sesionesList.length" message="No se han registrado sesiones" />


      <div class="d-flex justify-content-end">
        <b-button v-if="sesionesList.length && !onlyView" variant="primary" @click="onSaveSesiones">
          Guardar
        </b-button>
      </div>

    </b-card>

    <FormTerapiaPsicologica v-if="showModalPsi"/>

    <FormTerapiaNutricional v-if="showModalNut"/> 

    <FormOtraTerapia @sesion-guardada="refrescarDatos"  v-if="showModalOtra"/>
    
    <LoadMsp/>


  </ModalContainer>
</template>

<script>
import { ModalContainer, EmptyResults } from '@/shared/components';
import flatPickr from "vue-flatpickr-component";
import { Spanish } from 'flatpickr/dist/l10n/es';
import { sesionesTerapiaService, terapiasService } from '../services';
import { terapiasMapper } from '../helpers';
import FormTerapiaPsicologica from './FormTerapiaPsicologica.vue';
import FormTerapiaNutricional from './FormTerapiaNutricional.vue';
import { comprobarRoles } from '../../../shared/helpers';
import { ROLES } from '../../../shared/constants';
import FormOtraTerapia from './FormOtraTerapia.vue';
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import LoadMsp from './LoadMsp.vue';



export default {

  name: "FormSesionesTerapia",

  components: {
    ModalContainer,
    flatPickr,
    EmptyResults,
    FormTerapiaPsicologica,
    FormTerapiaNutricional,
    FormOtraTerapia,
    VueTimepicker,
    LoadMsp
    
  },

  props: {
    onlyView: {
      required:false,
      default:false
    }
  },


  created() {
    this.loadData();
  },

  data() {
    return {
      showModalPsi: false,
      showModalNut: false,
      showModalOtra: false,
      fechaSesion: null,
      horaSession: null,

      sesionesList: [],

      configFlatPicker: {
        enableTime: false,
        dateFormat: 'd/m/Y',
        locale: Spanish,
      },

      dataTerapia: null

    }
  },

  methods: {
        onShowFormMsp(tokenSesion) {
      this.navigateToQuery("msp", tokenSesion)
    },

    async refrescarDatos() {
    // 👇 Aquí haces lo que necesites para refrescar la data del padre
    await this.loadData(); // por ejemplo
  },
    
     


    async loadData() {

      this.tokenTerapia = this.$route.query.sessions;
      if (!this.tokenTerapia) return;

      const responseSearch = await terapiasService.getByToken(this.tokenTerapia);
      console.log("response search", responseSearch)
      this.dataTerapia = terapiasMapper(responseSearch);
      console.log("dataTerapia", this.dataTerapia)
      const responseSesiones = await sesionesTerapiaService.getSesionesByTerapia(this.tokenTerapia);

      if (!responseSesiones) return;


      this.sesionesList = responseSesiones.map(sesion => {

        return {
          action: 'registrado',
          idRegistro: sesion.id,
          tokenSesion: sesion.token,
          estadoSesion: sesion.estadoSesion,
          fechaSesion: sesion.fechaSesion,
          horaSesion: sesion.horaSesion,
          terapiaEnvio: sesion.solicitudTerapia
        }
      })
    },

    async addSesion() {

      if (!this.fechaSesion || !this.horaSession) {
        this.$swal({
          icon: 'error',
          text: 'Debe seleccionar una fecha y hora',
          showConfirmButton: true,
        });

        return;
      }

       if (this.sesionesList.length === this.dataTerapia.cantidad) {
        this.$swal({
          icon: 'error',
          text: 'No puede agregar mas sesiones que las que el medico envio',
          showConfirmButton: true,
        });

        return;
      }


      const newSession = {
        action: 'crear',
        estadoSesion: 'pendiente',
        fechaSesion: this.fechaSesion,
        horaSesion: this.horaSession.HH + ':' + this.horaSession.mm,
      }

      this.sesionesList.push(newSession);

      this.fechaSesion = null;
      this.horaSession = null;
    },


    async onSaveSesiones() {

      const result = await this.$swal.fire({
        title: 'Agregar sesion',
        text: "Esta seguro de guardar la informacion de las sesiones?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, agregar!',
        cancelButtonText: 'Cancelar',
      });

      if (!result.isConfirmed) return;

      const sesionesSinTerapiaEnvio = this.sesionesList.map(({ terapiaEnvio, ...rest }) => rest);

      const saveResponse = await terapiasService.processSesiones(this.tokenTerapia, sesionesSinTerapiaEnvio);

      if (!saveResponse) {
        this.$swal({
          icon: 'error',
          text: 'Ocurrio un error al guardar las sesiones',
          showConfirmButton: true,
        });
        return;
      }

      await this.$swal({
        icon: 'success',
        text: 'Se han guardado las sesiones',
        showConfirmButton: true,
      });

      this.loadData();
    },


    onProcesarSesion(sesion) {
      console.log('sesion que llega', sesion)

      const tokenSesion = sesion.tokenSesion;
      const tipoTerapia = sesion.terapiaEnvio.terapia.tipoTerapia.id;

      let tipoFormulario = null;

      console.log("CUAL ES EL TIPO DE TERAPIA", tipoTerapia)

      if (tipoTerapia === '1') tipoFormulario = 'psi';
      if (tipoTerapia === '2') tipoFormulario = 'nut';
      if (tipoTerapia !== '1' && tipoTerapia !== '2') tipoFormulario = 'gen';

      if (!tipoFormulario) return;

      this.navigateToQuery(tipoFormulario, tokenSesion);
    },

    getVariantCard(action) {

      const variant = action === 'registrado'
        ? 'success'
        : action === 'eliminar'
          ? 'danger'
          : 'info';

      return variant;
    },


    async onRemoveItemList(index) {

      const result = await this.$swal.fire({
        title: 'Eliminar Item Examen',
        text: "Estas seguro de eliminar este examen?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Eliminar!',
        cancelButtonText: 'Cancelar',
      });

      if (!result.isConfirmed) return;

      if (this.sesionesList[index].action === 'registrado') {
        this.sesionesList[index].action = 'eliminar';
        return;
      }

      this.sesionesList.splice(index, 1)
    },

    onRestoreItem(index) {
      this.sesionesList[index].action = 'registrado'
    },

    navigateToQuery(queryParam, valueQuery) {

      
      if(queryParam && queryParam === 'psi'){
        this.showModalPsi = true
      }
      else if(queryParam && queryParam === 'nut'){
        this.showModalNut = true
      }
      else {
        this.showModalOtra = true
      }

      
      try {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            [queryParam]: valueQuery,
          },
        });
      } catch (error) {
        console.error("Error en la navegación:", error);
      }
    },
     parseFechaHora(fecha, hora) {
    // Convertir "21/08/2025" a "2025-08-21"
    const [dia, mes, anio] = fecha.split('/');
    const isoString = `${anio}-${mes}-${dia}T${hora}`;
    return new Date(isoString);
  }
  },

  computed: {
    canProcesarSesion() {
      return comprobarRoles([ROLES.DOCTOR]);
    },

    
 sesionesOrdenadas() {
    return [...this.sesionesList].sort((a, b) => {
      const fechaA = this.parseFechaHora(a.fechaSesion, a.horaSesion);
      const fechaB = this.parseFechaHora(b.fechaSesion, b.horaSesion);
      return fechaA - fechaB; // más reciente primero
    });
  }

  },


  watch: {

    '$route.query.sessions': {
      handler() {
        this.loadData();
      },
    },

  }

}
</script>
